import { render, staticRenderFns } from "./SliderBox.vue?vue&type=template&id=0a434eae&scoped=true&"
import script from "./SliderBox.vue?vue&type=script&lang=js&"
export * from "./SliderBox.vue?vue&type=script&lang=js&"
import style0 from "./SliderBox.vue?vue&type=style&index=0&id=0a434eae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a434eae",
  null
  
)

export default component.exports